import Button, { ButtonProps } from 'components/atoms/Button';
import classNames from 'classnames';
import { isFunction } from 'utils/common';
import { pushProgressive } from 'utils/router';

export interface BackButtonProps extends ButtonProps {
  route: string;
}

function BackButton({ route, ...rest }: BackButtonProps) {
  return (
    <Button
      type="transparent"
      icon="arrow-left"
      onClick={() => {
        pushProgressive(route);
        if (isFunction(rest.onClick)) rest.onClick();
      }}
      text="Back"
      className={classNames('mr-4', rest.className)}
      {...rest}
    />
  );
}

export default BackButton;
